import {Component, OnInit} from '@angular/core';
import {HttpStatusCode} from "@angular/common/http";
import {forkJoin} from "rxjs";
import {CustomMessageService, LocalStorageService, UtilService} from "library";
import {CommissionsService} from "projects/store/src/app/services/api/v1/commissions.service";
import { LocalStorageKey, Permission } from "projects/store/src/app/enums";
import {UserData} from "projects/store/src/app/interfaces";
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-commission-dashboard',
  templateUrl: './commission-dashboard.component.html',
  styleUrls: ['./commission-dashboard.component.scss']
})
export class CommissionDashboardComponent implements OnInit{
  labelBreadcrumb = 'Dashboard';
  loading = false;
  userData: UserData;
  title? : string;
  role: any;
  salesDayDescription = 'Hoy';
  numberSalesDay = 0;
  salesWeekDescription = 'Semana';
  numberSalesWeek = 0;
  salesMonthDescription = 'Mes';
  numberSalesMonth = 0;
  accumulatedBalance = 0;

  constructor(private commissionsService: CommissionsService,
              private customMessageService: CustomMessageService,
              private utilService: UtilService,
              private localStorageService: LocalStorageService) {
    this.userData = this.localStorageService.get(LocalStorageKey.data)
    this.role = this.userData.user.role.code;
    this.setTitle(this.role);
  }

  ngOnInit() {
    this.load(this.role)
  }
  setTitle(role: any){
    switch (role){
      case 'commercial_manager':
        this.title = 'Total de ventas de todas las tiendas';
        break;
      default:
        this.title = 'Mis ventas';
        break;
    }
  }
  load(rol: string) {
    this.utilService.enablePageLoading();
    const accumulatedCount$ = (rol === 'commercial_manager') ?
      this.commissionsService.getAccumulatedCountDealer(this.userData.distributor.id) :
      this.commissionsService.getAccumulatedCount(this.userData.user.id);

    const accumulatedBalance$ = this.commissionsService.getAccumulatedBalance(this.userData.user.id);

    forkJoin([accumulatedCount$, accumulatedBalance$]).subscribe({
      next: ([countResp, balanceResp]) => {
        if (countResp.status === HttpStatusCode.Ok) {
          const { today, week, month } = countResp.body.data;
          this.numberSalesDay = today.toString().padStart(2, "0");
          this.numberSalesWeek = week.toString().padStart(2, "0");
          this.numberSalesMonth = month.toString().padStart(2, "0");
        } else {
          this.customMessageService.responseNoticeHandler(countResp);
        }

        if (balanceResp.status === HttpStatusCode.Ok) {
          this.accumulatedBalance = balanceResp.body.data.accumulated_commissions;
        } else {
          this.customMessageService.responseNoticeHandler(balanceResp);
        }
        this.utilService.disablePageLoading();
      },
      error: (error) => {
        this.customMessageService.responseNoticeHandler(error);
        this.utilService.disablePageLoading();
      }
    });
  }


  protected readonly environment = environment;
  protected readonly Permission = Permission;
}
